import "./Privacy.css";

const Privacy = () => {
  return (
    <section className="legal-section">
      <h1>Privacy Policy</h1>
      <div className="legal-content">
        <p className="last-updated">Last updated: January 2026</p>

        <div className="legal-item">
          <h2>Information We Collect</h2>
          <ul>
            <li>Full name</li>
            <li>Email address</li>
            <li>Phone number (if provided)</li>
            <li>Country of residence</li>
            <li>Travel preferences and inquiry details</li>
          </ul>
        </div>

        <div className="legal-item">
          <h2>How We Use Your Information</h2>
          <p>
            The information you provide is used only to respond to inquiries and
            communicate regarding potential travel experiences in Bhutan.
          </p>
        </div>

        <div className="legal-item">
          <h2>Data Sharing</h2>
          <p>
            We do not sell, rent, or trade your personal information. Data is
            not shared with third parties unless required by law.
          </p>
        </div>

        <div className="legal-item">
          <h2>Data Retention & Security</h2>
          <p>
            Personal data is retained only as long as necessary to respond to
            inquiries and is protected using reasonable security measures.
          </p>
        </div>

        <div className="legal-item">
          <h2>Your Rights</h2>
          <p>
            You may request access, correction, or deletion of your personal
            information by contacting us at info@mystiquerealm.com.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Privacy;
